import { compose } from "redux";
import React, { PureComponent } from "react";
import { Route, Switch } from "react-router-dom";

import routePaths from "app/routePaths";
import LoginHeader from "features/login/components/LoginHeader";
import ViewHeader from "features/planner/components/View/ViewHeader";
import SettingsHeader from "features/planner/settings/components/SettingsHeader";
import EmployeeCardHeader from "features/planner/employee/components/EmployeeCardHeader";
import ReportHeaderContainer from "features/planner/report/components/ReportHeaderContainer";
import SubContractorCardHeader from "features/planner/subcontractor/components/SubContractorCardHeader";

class ApplicationHeader extends PureComponent {
  render() {
    return (
      <Switch>
        <Route
          exact
          component={ViewHeader}
          path={[routePaths.root, routePaths.view]}
        />
        <Route path="/settings" component={SettingsHeader} />
        <Route path="/reports" component={ReportHeaderContainer} />
        <Route
          path="/employee/:employeeCardId"
          component={EmployeeCardHeader}
        />
        <Route
          path="/sub-contractor/:employeeCardId"
          component={SubContractorCardHeader}
        />
        <Route component={LoginHeader} />
      </Switch>
    );
  }
}

export default compose()(ApplicationHeader);
